import MediBuddyName from "../assets/MediBuddyName.svg";
import { Link } from "react-router-dom";
import Phone from "../assets/Phone.svg";
import Email from "../assets/Email.svg";
import Facebook from "../assets/facebook.svg";
import Twitter from "../assets/twitter.svg";
import Instagram from "../assets/instagram.svg";
import Youtube from "../assets/youtube.svg";

export default function Footer() {
    return (
        <div className="bg-lightgrey h-full mt-60">
            <div className="mx-6 lg:mx-36 py-20 flex flex-col lg:flex-row space-y-16 lg:space-y-2 justify-between">
                <div className="flex flex-col lg:flex-row md:space-x-8 space-y-5 lg:space-y-0 items-center lg:items-start space-y-2 lg:space-y-2 lg:justify-between">
                    <a target="_blank" href="https://www.medibuddy.in/"><img className="w-36" src={MediBuddyName} /></a>
                    <a className="lg:relative lg:-top-1" target="_blank" href="https://www.medibuddy.in/aboutus/">About Us</a>
                    <div className="flex items-center lg:items-start space-y-2 lg:space-y-2 flex-col space-y-2">
                        <p>Connect With Us</p>
                        <div className="flex flex-col items-center md:flex-row space-x-4">
                            <div className="flex space-x-2">
                                <a href="tel:80-68239354"><img src={Phone} className="mr-2 inline" />80-68239354</a>
                            </div>
                            <div className="flex space-x-2">
                                <a href="mailto:Wellnesscare@medibuddy.in"><img src={Email} className="mr-2 inline" />Wellnesscare@medibuddy.in</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-center space-x-5">
                    <a target="_blank" href="https://www.facebook.com/MediBuddy/"><img src={Facebook} /></a>
                    <a target="_blank" href="https://twitter.com/MediBuddyapp"><img src={Twitter} /></a>
                    <a target="_blank" href="https://www.instagram.com/medibuddyapp/"><img src={Instagram} /></a>
                    <a target="_blank" href="https://www.youtube.com/channel/UCGD4TVd_w6q7HRv0yVZc58A/featured"><img src={Youtube} /></a>
                </div>
            </div>
            
        </div>
    );
}
